import React, { useEffect, useState } from "react";
import {
  getStockList,
  getLowStock,
} from "../../services/api/stocks/stockService";
import { useNavigate } from "react-router-dom";

const StockList = () => {
  const [stock, setStock] = useState([]);
  const [filteredStock, setFilteredStock] = useState([]);
  const [search, setSearch] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  const itemsPerPage = 10;

  useEffect(() => {
    fetchStock();
  }, []);

  const fetchStock = async () => {
    try {
      const res = await getStockList();
      setStock(res.data.data);
      setFilteredStock(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    let filtered = stock;

    if (search.trim() !== "") {
      filtered = filtered.filter((item) =>
        item.item_name?.toLowerCase().includes(search.trim().toLowerCase()),
      );
    }

    if (filterType === "low") {
      filtered = filtered.filter((item) => item.available_qty < 10);
    }

    setFilteredStock(filtered);
    setCurrentPage(1);
  }, [search, filterType, stock]);

  const totalPages = Math.ceil(filteredStock.length / itemsPerPage);

  const paginatedData = filteredStock.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const visiblePages = Array.from(
    { length: totalPages },
    (_, i) => i + 1,
  ).filter((p) => Math.abs(p - currentPage) <= 2);

  return (
    <div className="p-4 md:p-6 bg-white rounded-xl shadow-md">
      <div className="flex flex-col md:flex-row justify-between gap-4 mb-4">
        <h2 className="text-xl font-semibold">Stock Management</h2>

        <div className="flex flex-col md:flex-row gap-3">
          <input
            type="text"
            placeholder="Search item..."
            className="border px-3 py-2 rounded-md w-full md:w-64"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <select
            className="border px-3 py-2 rounded-md"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            <option value="all">All Stock</option>
            <option value="low">Low Stock</option>
          </select>
        </div>
      </div>

      <div className="hidden md:block overflow-x-auto">
        <table className="min-w-full table-fixed border rounded-lg">
          <thead className="bg-gray-100">
            <tr className="text-left">
              <th className="p-3 w-16">SlNo</th>
              <th className="p-3 w-64">Item Name</th>
              <th className="p-3 w-32">Available Qty</th>
              <th className="p-3 w-24">Unit</th>
              <th className="p-3 w-32">Status</th>
              <th className="p-3 w-40">Action</th>
            </tr>
          </thead>

          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((item, index) => (
                <tr key={index} className="border-t">
                  <td className="p-3">{index + 1}</td>
                  <td className="p-3 break-words whitespace-normal">
                    {item.item_name || "-"}
                  </td>

                  <td className="p-3">{item.available_qty}</td>

                  <td className="p-3">{item.unit || "-"}</td>

                  <td className="p-3">
                    {item.available_qty < 10 ? (
                      <span className="text-red-600 font-medium">
                        Low Stock
                      </span>
                    ) : (
                      <span className="text-green-600 font-medium">
                        Available
                      </span>
                    )}
                  </td>
                  <td className="p-3 flex gap-2">
                    <button
                      className="px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded"
                      onClick={() => navigate(`/stock/${item.id}`)}
                    >
                      View
                    </button>

                    <button
                      onClick={() => navigate(`/stock-ledger/${item.id}`)}
                      className="px-3 py-1 bg-green-500 hover:bg-green-600 text-white rounded"
                    >
                      Ledger
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="p-4 text-center">
                  No stock found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* mobile layout */}
      <div className="md:hidden space-y-3">
        {paginatedData.map((item, index) => (
          <div key={index} className="border rounded-lg p-3 shadow-sm">
            <div className="flex justify-between">
              <p className="font-semibold text-sm">
                {(currentPage - 1) * itemsPerPage + index + 1}. {item.item_name}
              </p>
              <span
                className={`text-xs font-medium ${
                  item.available_qty < 10 ? "text-red-600" : "text-green-600"
                }`}
              >
                {item.available_qty < 10 ? "Low" : "OK"}
              </span>
            </div>

            <div className="text-xs mt-2 space-y-1">
              <p>
                <strong>Qty:</strong> {item.available_qty}
              </p>
              <p>
                <strong>Unit:</strong> {item.unit || "-"}
              </p>
            </div>

            <div className="flex gap-2 mt-3">
              <button
                className="flex-1 px-2 py-1 bg-blue-500 text-white rounded text-xs"
                onClick={() => navigate(`/stock/${item.id}`)}
              >
                View
              </button>
              <button
                className="flex-1 px-2 py-1 bg-green-500 text-white rounded text-xs"
                onClick={() => navigate(`/stock-ledger/${item.id}`)}
              >
                Ledger
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-4 gap-2 flex-wrap">
        {visiblePages.map((page) => (
          <button
            key={page}
            className={`px-3 py-1 rounded ${
              currentPage === page ? "bg-blue-600 text-white" : "bg-gray-200"
            }`}
            onClick={() => setCurrentPage(page)}
          >
            {page}
          </button>
        ))}
      </div>
    </div>
  );
};

export default StockList;
